import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Box, Loader } from '@wix/design-system';
import { ThemedTextButton } from '../ThemedComponents';
import { AppContextProvider } from '../AppLoader';
import { EnterCodeContextProvider } from '../EnterCode/EnterCode';
import { useTwoFactorAuth } from '../../stores/twoFactorAuth';
import {
  TwoFactorAuthMethods,
  twoFactorSwitchMethodKeysMap,
} from '../../utils/constants';

export const TwoFAMethods: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore: { notificationStore },
  } = useContext(AppContextProvider);
  const { store, enterCodeStore } = useContext(EnterCodeContextProvider);
  const { store: twoFactorAuthStore } = useTwoFactorAuth();

  const isLoading =
    enterCodeStore?.isSwitchingMethod || twoFactorAuthStore.isLoading;

  // Clear any existing notification on mount
  useEffect(() => {
    notificationStore.close();
  }, [notificationStore]);

  // Filter out current method, keep server order (including WebAuthn)
  const methodsToShow = store?.enabledTwoFAMethods?.filter(
    (method) => method !== store.currentTwoFAMethod,
  );

  return (
    <Box align="center" verticalAlign="middle" direction="vertical" gap="5px">
      {isLoading && <Loader size="tiny" />}
      {!isLoading &&
        methodsToShow?.map((method) => {
          const isPasskey = method === TwoFactorAuthMethods.WebAuthn;
          return (
            <ThemedTextButton
              key={method}
              underline="always"
              size="small"
              disabled={isLoading}
              onClick={() =>
                isPasskey
                  ? twoFactorAuthStore.verifyWithWebAuthn(
                      enterCodeStore?.rememberMe,
                    )
                  : store && enterCodeStore?.onSwitchMethod(method, store)
              }
            >
              {t(twoFactorSwitchMethodKeysMap[method])}
            </ThemedTextButton>
          );
        })}
    </Box>
  );
});
